import Vue from "vue";
import {API_HOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class AdminTemplateService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }
    getAdminTemplates(){
        return Vue.axios.get(`${API_HOST}/api/admintemplate`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    download({id}){
        return Vue.axios.get(`${API_HOST}/api/admintemplate/download`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: id
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    postTemplate({templateData}) {
        return Vue.axios.post(`${API_HOST}/api/admintemplate`, {
            Name: templateData.Name,
            OrganizationId: templateData.OrganizationId,
            Base64Content: templateData.Base64Content
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        })
    }

    putTemplate({templateData}) {
        return Vue.axios.put(`${API_HOST}/api/admintemplate`, {
            Id: templateData.Id,
            Name: templateData.Name,
            OrganizationId: templateData.OrganizationId,
            Base64Content: templateData.Base64Content
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        })
    }
}

export default new AdminTemplateService()